import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("mask", {
      id: "a",
      width: "24",
      height: "24",
      x: "0",
      y: "0",
      maskUnits: "userSpaceOnUse",
      style: {"mask-type":"alpha"}
    }, [
      _createElementVNode("path", {
        fill: "#D9D9D9",
        d: "M0 0h24v24H0z"
      })
    ], -1),
    _createElementVNode("g", { mask: "url(#a)" }, [
      _createElementVNode("path", {
        fill: "#114A4E",
        d: "M12 16q1.875 0 3.188-1.313Q16.5 13.375 16.5 11.5t-1.313-3.188Q13.875 7.002 12 7q-1.875 0-3.188 1.313Q7.502 9.625 7.5 11.5q0 1.875 1.313 3.188Q10.125 16 12 16m0-1.8q-1.125 0-1.912-.787A2.6 2.6 0 0 1 9.3 11.5q0-1.125.787-1.912A2.6 2.6 0 0 1 12 8.8q1.125 0 1.912.787.788.789.788 1.913c0 1.124-.262 1.387-.787 1.912A2.6 2.6 0 0 1 12 14.2m0 4.8q-3.65 0-6.65-2.038T1 11.5q1.35-3.424 4.35-5.463Q8.35 4.001 12 4t6.65 2.037q3 2.039 4.35 5.463-1.35 3.425-4.35 5.462-3 2.039-6.65 2.038m0-2a9.54 9.54 0 0 0 5.188-1.488A9.77 9.77 0 0 0 20.8 11.5a9.77 9.77 0 0 0-3.613-4.013A9.55 9.55 0 0 0 12 6a9.55 9.55 0 0 0-5.188 1.487A9.77 9.77 0 0 0 3.2 11.5a9.77 9.77 0 0 0 3.612 4.012A9.54 9.54 0 0 0 12 17"
      })
    ], -1)
  ])))
}
export default { render: render }